import React, {FC} from 'react';
import {useWaitListData} from 'components/ContentPagesComponents/WaitList';
import {WaitListModalWrapper} from 'components/ContentPagesComponents/WaitListModal';

import {PopupCoverImage} from './_PopupCoverImage';

export interface WaitListCoverImage {
    template: string;
    subTitle: string;
    actionBtnText: string;
    path: string;
}

export const WaitListCoverImage: FC<WaitListCoverImage> = ({
	template,
	path,
	...props
}) => {
	const {data} = useWaitListData(path);
	if (!data) {
		return null;
	}

	// Compute title from template and dynamic data
	const title = template
		.replace('${location}', data?.list?.location || '');

	return (
		<PopupCoverImage
			{...props}
			title={title}
			component={WaitListModalWrapper(path)}
			imageSrc={data?.list?.desktop.url || ''}
			mobileSrc={data?.list?.mobile?.url}
		/>
	);
};
